module.exports = __webpack_public_path__ + "static/media/035-bold-arrow-down.813204e3.svg";